import { useMediaQuery } from '@react-hooks-library/core';
import Ad from 'src/components/ads/Ad';
import ButtonLink from 'src/components/buttonlink/ButtonLink';
import PopularMoviesList from 'src/components/popularmovieslist/PopularMoviesList';
import classNames from 'classnames';
import styles from './PopularMoviesRow.module.css';


//#region [Props]
type PopularMoviesRowProps = {
    className?: string;
};
//#endregion

//#region [Component]
export default function PopularMoviesRow({ className }: PopularMoviesRowProps) {
    const isDesktop = useMediaQuery("(min-width: 550px)");
    return <div className={classNames(styles.SPopularMoviesRow, className)}>
        <div className={classNames(styles.SPosterRow)}>
            <PopularMoviesList hideHeader />
            <ButtonLink className={classNames(styles.SToProgramButtonLink)} href='/program'>Se hele kinoprogrammet</ButtonLink>
        </div>
        {isDesktop && <Ad className={classNames(styles.SMpuAd)} targetId='FW_MPU_forside' canHide={false} />}
    </div>;
}
//#endregion

//#region [Styles]
// Moved to CSS Modules (PopularMoviesRow.module.css)
//#endregion
